// extracted by mini-css-extract-plugin
export default {"modalText":"h_IQoOlpy3V7ZMmAoUQ2"};